import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "45",
  height: "51",
  fill: "none"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createStaticVNode("<path stroke=\"#fff\" stroke-linecap=\"round\" stroke-linejoin=\"round\" stroke-width=\"2\" d=\"M2.67 10.723c5.374.955 16.956.168 20.291-9.223\"></path><path stroke=\"#fff\" stroke-linecap=\"round\" stroke-linejoin=\"round\" stroke-width=\"2\" d=\"M42.33 10.723c-5.115.871-16.248-.608-19.423-9.181\"></path><path stroke=\"#fff\" stroke-linecap=\"round\" stroke-width=\"2\" d=\"M2.67 10.723C.437 21.236 1.267 43.437 22.5 49c21.233-5.563 22.064-27.764 19.83-38.277\"></path><circle cx=\"23.026\" cy=\"25.592\" r=\"9.307\" fill=\"#36A5A2\" stroke=\"#fff\" stroke-width=\"2\"></circle><path stroke=\"#fff\" stroke-linecap=\"round\" stroke-linejoin=\"round\" stroke-width=\"2\" d=\"m26.049 22.589-6.026 6.025M20.004 22.589l6.025 6.025\"></path>", 5)
  ]))]))
}
export default { render: render }